import React, { useEffect, useState } from 'react';
import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from 'polotno';
import { Toolbar } from 'polotno/toolbar/toolbar';
import { PagesTimeline } from 'polotno/pages-timeline';
import { ZoomButtons } from 'polotno/toolbar/zoom-buttons';
import { Workspace } from 'polotno/canvas/workspace';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import '@blueprintjs/core/lib/css/blueprint.css';

import { createStore } from 'polotno/model/store';
import { useNavigate } from 'react-router-dom';
import { dimensions } from '../utils/helper';
import Sidebar from '../page/private/PolotnoDesign/Sidebar';

const store = createStore({
	key: 'gj22OYPNEiZGOv4RvhGx', // you can create it here: https://polotno.com/cabinet/
	// you can hide back-link on a paid license
	// but it will be good if you can keep it for Polotno project support
	showCredit: false,
});
// const page = store.addPage();
const masterPage = store.addPage({
	name: 'master',
	width: dimensions.L.width,
	height: dimensions.L.height,
	id: 'master',
});
export default function DeepakDesign() {
	const [isNameAdded, setIsNameAdded] = useState(false);
	useEffect(() => {
		const addAllPages = () => {
			Object.keys(dimensions)?.forEach((size) => {
				const newPage = store.addPage({
					name: size.split(' ').join('_'),
					width: dimensions[size].width,
					height: dimensions[size].height,
					id: size.split(' ').join('_'),
					custom: { size: size },
				});
			});
		};
		addAllPages();
	}, []);

	const Tooltip = () => null;

	const removeSelectedElementFromActivePage = () => {
		const activePage = store.activePage;
		if (!activePage) return;

		const ids = store.selectedElements.map((el) => el.id);
		if (!ids.length) return;

		runInAction(() => {
			const updatePage = (page) => {
				page.set({
					custom: {
						...page.custom,
						removedElements: [...(page.custom?.removedElements || []), ...ids],
					},
				});

				page.children.forEach((child) => {
					if (ids.includes(child.id)) {
						child.set({ opacity: 0, selectable: false, evented: false }); // Hide element
					}
				});
			};

			// Remove from all pages if master, otherwise just active page
			activePage.id === 'master'
				? store.pages.forEach(updatePage)
				: updatePage(activePage);
		});
	};

	const Remove = observer(({ store }) => {
		return (
			<button
				style={{
					background: 'red',
					color: 'white',
					border: 'none',
					padding: '8px 12px',
					cursor: 'pointer',
					borderRadius: '5px',
				}}
				onClick={() => removeSelectedElementFromActivePage(store)}>
				Remove Element
			</button>
		);
	});

	// const syncChanges = (masterPage, targetPage) => {
	//   runInAction(() => {
	//     const targetElementsMap = new Map(targetPage.children.map((child) => [child.id, child]));
	//     const removedElements = new Set([
	//       ...(targetPage.custom?.removedElements || []),
	//       ...(masterPage.custom?.removedElements || []),
	//     ]);

	//     masterPage.children.forEach((masterObject) => {
	//       const masterData = masterObject.toJSON();
	//       console.log('masterData is', masterData, ' and masterObject is', masterObject)
	//       if (removedElements.has(masterData.id)) return; // Skip removed elements

	//       const targetObject = targetElementsMap.get(masterData.id);
	//       targetObject ? targetObject.set(masterData) : targetPage.addElement(JSON.parse(JSON.stringify(masterData)));
	//     });
	//   });
	// };
	const syncChanges = (masterPage, targetPage) => {
		runInAction(() => {
			console.log('inside syncchanges');
			const targetElementsMap = new Map(
				targetPage.children.map((child) => [child.id, child])
			);
			const removedElements = new Set([
				...(targetPage.custom?.removedElements || []),
				...(masterPage.custom?.removedElements || []),
			]);

			masterPage.children.forEach((masterObject) => {
				const masterData = masterObject.toJSON();
				const uniqueId = `${masterData.id}-${targetPage.id}`;

				if (
					removedElements.has(masterData.id) ||
					removedElements.has(uniqueId)
				) {
					return;
				}

				const targetObject = targetElementsMap.get(uniqueId);

				if (targetObject) {
					// Compare properties
					if (
						targetObject.width === targetObject.custom?.originalWidth &&
						targetObject.height === targetObject.custom?.originalHeight &&
						targetObject.x === targetObject.custom?.originalX &&
						targetObject.y === targetObject.custom?.originalY &&
						targetObject.scaleX === targetObject.custom?.originalScaleX &&
						targetObject.scaleY === targetObject.custom?.originalScaleY &&
						targetObject.angle === targetObject.custom?.originalAngle
					) {
						// Properties match, check master for changes.
						const masterElement = masterPage.children.find(
							(child) => child.id === masterData.id
						);

						if (
							masterElement.width !==
								targetObject.custom?.originalMasterWidth ||
							masterElement.height !==
								targetObject.custom?.originalMasterHeight ||
							masterElement.x !== targetObject.custom?.originalMasterX ||
							masterElement.y !== targetObject.custom?.originalMasterY ||
							masterElement.scaleX !==
								targetObject.custom?.originalMasterScaleX ||
							masterElement.scaleY !==
								targetObject.custom?.originalMasterScaleY ||
							masterElement.angle !== targetObject.custom?.originalMasterAngle
						) {
							// Master has changed, update size page.
							targetObject.set({
								...masterData,
								id: targetObject.id,
							});
							// Update the original master values in the size page, so that next sync will know the master has changed.
							targetObject.set({
								custom: {
									originalWidth: targetObject.width,
									originalHeight: targetObject.height,
									originalX: targetObject.x,
									originalY: targetObject.y,
									originalScaleX: targetObject.scaleX,
									originalScaleY: targetObject.scaleY,
									originalAngle: targetObject.angle,
									originalMasterWidth: masterElement.width,
									originalMasterHeight: masterElement.height,
									originalMasterX: masterElement.x,
									originalMasterY: masterElement.y,
									originalMasterScaleX: masterElement.scaleX,
									originalMasterScaleY: masterElement.scaleY,
									originalMasterAngle: masterElement.angle,
								},
							});

							console.log('Master changed, updating size page:', uniqueId);
						}
					} else {
						console.log(
							'Element modified on size page, skipping update:',
							uniqueId
						);
					}
				} else {
					const targetElement = targetPage.addElement({
						...masterData,
						id: uniqueId,
					});
					targetElement.set({
						custom: {
							originalWidth: targetElement.width,
							originalHeight: targetElement.height,
							originalX: targetElement.x,
							originalY: targetElement.y,
							originalScaleX: targetElement.scaleX,
							originalScaleY: targetElement.scaleY,
							originalAngle: targetElement.angle,
							originalMasterWidth: masterData.width,
							originalMasterHeight: masterData.height,
							originalMasterX: masterData.x,
							originalMasterY: masterData.y,
							originalMasterScaleX: masterData.scaleX,
							originalMasterScaleY: masterData.scaleY,
							originalMasterAngle: masterData.angle,
						},
					});
				}
			});
		});
	};

	store.on('change', () => {
		const activePage = store.activePage;
		if (activePage?.id !== 'master') {
			activePage.children.forEach((child) => {
				if (child.type === 'text') {
					child.set({ custom: { ...child.custom, modified: true } });
				}
			});
		}
	});

	useEffect(() => {
		const unsubscribe = store.on('object:added', (obj) => {
			if (
				store.activePage?.id !== 'master' &&
				obj.target &&
				obj.target.page.id !== 'master'
			) {
			}
		});

		const unsubscribeModified = store.on('object:modified', (obj) => {
			if (store.activePage?.id !== 'master' && obj.target) {
				//update the original values.
				obj.target.set({
					custom: {
						originalWidth: obj.target.width,
						originalHeight: obj.target.height,
						originalX: obj.target.x,
						originalY: obj.target.y,
						originalScaleX: obj.target.scaleX,
						originalScaleY: obj.target.scaleY,
						originalAngle: obj.target.angle,
					},
				});
			}
		});

		return () => {
			unsubscribe();
			unsubscribeModified();
		};
	}, []);

	useEffect(() => {
		const changeHandler = () => {
			if (store.activePage?.id === 'master') {
				store.pages.forEach((page) => {
					if (page.id !== 'master') {
						syncChanges(masterPage, page);
					}
				});
			}
		};

		const unsubscribe = store.on('change', () => {
			localStorage.setItem('polotnoCanvas', JSON.stringify(store.toJSON()));
			changeHandler();
		});
		return () => {
			unsubscribe();
		};
	}, []);

	const addOrRemoveName = (page) => {
		const centerX = page.width / 2;
		const centerY = page.height / 2;
		const found = page?.children?.find((child) => {
			return child.id === page.id + '_playernametext';
		});
		if (found) {
			found.set({ visible: !found.visible, x: centerX, y: centerY });
		} else {
			page.addElement({
				id: page.id + '_playernametext',
				type: 'text',
				x: centerX,
				y: centerY,
				fill: 'black',
				text: 'Player Name',
			});
		}
	};

	const handleAddName = () => {
		const activePage = store.activePage;
		if (activePage && activePage.id === 'master') {
			store.pages.forEach((page) => {
				addOrRemoveName(page);
			});
		} else {
			const foundPage = store.pages.find((page) => page.id === activePage.id);
			if (foundPage) {
				addOrRemoveName(foundPage);
			}
		}
		// console.log("activepage is", activePage);
	};

	const navigate = useNavigate();

	const navigateHomePage = () => {
		navigate('/');
	};
	// const navigateVariationPage = () => {
	//   navigate("/vari");
	// };
	const navigateExportPage = () => {
		navigate('/export');
	};
	const Duplicate = () => null;
	return (
		<>
			<button onClick={handleAddName}>Add Player Name</button>
			<button onClick={navigateHomePage}>Go to Home page</button>
			{/* <button onClick={navigateVariationPage}>Go to variation page</button> */}
			<button onClick={navigateExportPage}>Go to export page</button>

			<PolotnoContainer style={{ width: '100vw', height: '100vh' }}>
				<SidePanelWrap>
					<Sidebar store={store} />
				</SidePanelWrap>
				<WorkspaceWrap>
					<Toolbar store={store} components={{ Remove }} />
					<Workspace
						store={store}
						components={{ Remove, PageControls: Duplicate }}
					/>
					<ZoomButtons store={store} />
					<PagesTimeline store={store} />
				</WorkspaceWrap>
			</PolotnoContainer>
		</>
	);
}
